import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import useGetEmployees from "../../../../hooks/queries/admin/useGetEmployees";
import Loader from "../../../../components/Loader";
import ErrorPage from "../../../../components/ErrorPage";
import {
  PageContainer,
  ContentContainer,
  HeaderGradient,
  StatBox,
  StatValue,
} from "../components";
import { ReactComponent as TwoPersonIcon } from "../../../../assets/icons/adminDashboard/twoPerson.svg";
import TableContainer from "../../../../components/TableContainer";
import {
  TableCellHeader,
  TableCellRow,
} from "../../../../components/TableCell";

type Props = {};

const Employees = (props: Props) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const { data, status } = useGetEmployees({ page: page + 1 });

  if (status === "loading") return <Loader />;
  if (status === "error") return <ErrorPage />;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const enrolledCount = data?.count.toLocaleString() || "0";
  return (
    <PageContainer>
      <HeaderGradient
        title="Employees"
        subtitle="Review and update your enrolled employees"
      />
      <ContentContainer>
        <div className="w-100">
          <StatBox title="Participating Employees" Icon={TwoPersonIcon}>
            <StatValue value={enrolledCount} />
          </StatBox>
        </div>
        <div className="w-100 mt-16" style={{ marginBottom: "128px" }}>
          <TableContainer title="Enrolled" subtitle={enrolledCount}>
            <Table sx={{ minWidth: 650 }} aria-label="table header">
              <TableHead sx={{ background: "#f9fafb", height: 47 }}>
                <TableRow>
                  <TableCellHeader>Name</TableCellHeader>
                  <TableCellHeader>Email</TableCellHeader>
                  <TableCellHeader>Account #</TableCellHeader>
                  <TableCellHeader>Routing #</TableCellHeader>
                  <TableCellHeader>Contribution</TableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.results.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCellRow component="th" scope="row">
                      {row.user.first_name} {row.user.last_name}
                    </TableCellRow>
                    <TableCellRow component="th" scope="row">
                      {row.user.email}
                    </TableCellRow>
                    <TableCellRow component="th" scope="row">
                      {row.account?.tp_account_number}
                    </TableCellRow>
                    <TableCellRow component="th" scope="row">
                      {row.account?.tp_routing_number}
                    </TableCellRow>
                    <TableCellRow component="th" scope="row">
                      ${row.ssp_ygbm_monthly_contribution}/month
                    </TableCellRow>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[25]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) =>
                setRowsPerPage(e.target.value as unknown as number)
              }
              count={data.count}
              page={page}
              onPageChange={handleChangePage}
              component="div"
              sx={{ background: "#f9fafb" }}
            />
          </TableContainer>
        </div>
      </ContentContainer>
    </PageContainer>
  );
};

export default Employees;
